"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElevationSettings = void 0;
/*
 * Copyright (c) 2023 Discover Financial Services
 * Licensed under MIT License. See License.txt in the project root for license information
 */
const atom_1 = require("./atom");
const props_1 = require("../common/props");
/**
 * The elevation settings atom.
 * @category Atoms
 */
class ElevationSettings extends atom_1.Atom {
    constructor(atoms) {
        super("Elevation Settings", false, atoms);
        this.addDependency(atoms.colorThemes);
        this.shadowColor = new props_1.PropertyString("Color", false, this, { defaultValue: "#000000" });
        // TODO: What are the numeric ranges for the radius, opacity, and shadow length?
        this.baseBlurRadius = new props_1.PropertyNumberRange("Base Blur Radius", false, this, 0, 10, 2);
        this.baseSpreadRadius = new props_1.PropertyNumberRange("Base Spread Radius", false, this, 0, 10, 2);
        this.baseColorOpacity = new props_1.PropertyNumberRange("Base Color Opacity", false, this, 0, 100, 4);
        this.horizontalShadowLength = new props_1.PropertyNumberRange("Horizontal Shadow Length", false, this, 0, 10, 2);
        this.verticalShadowLength = new props_1.PropertyNumberRange("Vertical Shadow Length", false, this, 0, 10, 2);
        this.blurRadius = new props_1.PropertyNumberRange("Blur Radius", false, this, 0, 10, 2);
        this.spreadRadius = new props_1.PropertyNumberRange("Spread Radius", false, this, 0, 10, 2);
        this.colorOpacity = new props_1.PropertyNumberRange("Color Opacity", false, this, 0, 100, 4);
        this.percentageChange = new props_1.PropertyPercentage("Percentage Change", false, this, 20);
    }
    deserialize(obj) {
        if (!obj)
            return;
        super.deserialize(obj);
        this.shadowColor.deserialize(obj.shadowColor);
        this.baseBlurRadius.deserialize(obj.baseBlurRadius);
        this.baseSpreadRadius.deserialize(obj.baseSpreadRadius);
        this.baseColorOpacity.deserialize(obj.baseColorOpacity);
        this.horizontalShadowLength.deserialize(obj.horizontalShadowLength);
        this.verticalShadowLength.deserialize(obj.verticalShadowLength);
        this.blurRadius.deserialize(obj.blurRadius);
        this.spreadRadius.deserialize(obj.spreadRadius);
        this.colorOpacity.deserialize(obj.colorOpacity);
        this.percentageChange.deserialize(obj.percentageChange);
    }
    serialize() {
        const obj = {};
        obj.shadowColor = this.shadowColor.serialize();
        obj.baseBlurRadius = this.baseBlurRadius.serialize();
        obj.baseSpreadRadius = this.baseSpreadRadius.serialize();
        obj.baseColorOpacity = this.baseColorOpacity.serialize();
        obj.horizontalShadowLength = this.horizontalShadowLength.serialize();
        obj.verticalShadowLength = this.verticalShadowLength.serialize();
        obj.blurRadius = this.blurRadius.serialize();
        obj.spreadRadius = this.spreadRadius.serialize();
        obj.colorOpacity = this.colorOpacity.serialize();
        obj.percentageChange = this.percentageChange.serialize();
        return obj;
    }
}
exports.ElevationSettings = ElevationSettings;
